import { createStore } from 'zustand/vanilla';
import { persist } from 'zustand/middleware';
import { subscribeWithSelector } from 'zustand/middleware';

export type Settings = {
    muted: boolean;
    spineDebug: boolean;
    soundDebug: boolean;
    wsDebug: boolean;
    storeDebug: boolean;
    roundDebug: boolean;
    spineSpeed: number;
    toggleSound: () => void;
};

export const settingsStore = createStore<Settings>()(
    subscribeWithSelector(
        persist(
            (set) => ({
                muted: false,
                spineDebug: false,
                soundDebug: false,
                wsDebug: false,
                storeDebug: false,
                roundDebug: false,
                spineSpeed: 0.1,
                hasHydrated: () => settingsStore.persist.hasHydrated(),
                toggleSound: () => set((state) => ({ muted: !state.muted })),
            }),
            {
                name: 'settings-storage',
                partialize: (state) => ({
                    muted: state.muted,
                    spineSpeed: state.spineSpeed,
                }),
            },
        ),
    ),
);

export function waitForSettingsHydration(): Promise<void> {
    return new Promise((resolve) => {
        if (settingsStore.persist.hasHydrated()) {
            resolve();
        } else {
            const unsub = settingsStore.persist.onFinishHydration(() => {
                unsub();
                resolve();
            });
        }
    });
}
